<template>
  <WarRoomCommissionEarnBannerCard>
    <div slot="header" class="war-room-commission-earn-banner-gift__header">
      Earn Commission
      <QuestionIcon class="war-room-commission-earn-banner-gift__icon" @click="openFAQ" />
    </div>
    <div slot="content" class="war-room-commission-earn-banner-gift__content">
      <div class="war-room-commission-earn-banner-gift__image">
        <NuxtImg
          alt=""
          :src="product.image_url"
          width="80"
          height="80"
          class="war-room-commission-earn-banner-gift__picture"
        />
      </div>
      <div class="war-room-commission-earn-banner-gift__hint">
        Well done, {{ $auth.user.username }}! Now you have enough commission to get your first reward:
      </div>
      <div class="war-room-commission-earn-banner-gift__name">
        {{ product.name }}
      </div>
      <BravadoButtonV3 variant="secondary" to="/war-room/products" @click.native="handleExchangeClick">
        Commission Store
      </BravadoButtonV3>
    </div>
  </WarRoomCommissionEarnBannerCard>
</template>

<script>
import WarRoomCommissionEarnBannerCard from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerCard';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3';
import { FAQPostUri } from '@/components/partials/war-room/WarRoomCommissionEarnBanner/constants';
import QuestionIcon from '@/assets/svg/question.vue.svg';

export default {
  name: 'WarRoomCommissionEarnBannerGift',
  components: {
    WarRoomCommissionEarnBannerCard,
    QuestionIcon,
    BravadoButtonV3,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  mounted() {
    this.$analytics.logEvent('war-room__all-posts__gift__shown');
  },
  methods: {
    openFAQ() {
      this.$router.push(FAQPostUri);
    },
    handleExchangeClick() {
      this.$analytics.logEvent('war-room__all-posts__gift-commission-exchange__click');
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-commission-earn-banner-gift {
  color: var(--theme-color-sub-text);

  &__header {
    height: 36px;

    @include flex-center;

    color: var(--blue-60);
    background: var(--blue-60-a20);

    @include subhead-semibold;

    padding: 0 8px;
  }

  &__icon {
    color: var(--blue-60);
    margin-left: 4px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: var(--blue-50);
    }
  }

  &__content {
    color: var(--theme-color-sub-text);
    text-align: center;
    padding-top: 8px;
  }

  &__hint {
    @include subhead;

    color: inherit;
    margin: 8px 0;
  }

  &__name {
    @include body-semibold;

    color: inherit;
    margin-bottom: 12px;
  }

  &__image {
    text-align: center;
    line-height: 0;
    height: 112px;
    display: inline-block;
    background: var(--white);
    border-radius: 8px;
    padding: 16px;
    width: 100%;
    margin-bottom: 8px;
  }

  &__picture {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}
</style>
